<template>
  <div>
    <span>{{ value }}{{ getSingleVar.unit }}</span>
  </div>
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';


const defaultFormat = '%.0f';

const formats = {
  '%.0f': value => value.toFixed(0),
  '%.1f': value => value.toFixed(1),
  '%.2f': value => value.toFixed(2),
  '%.3f': value => value.toFixed(3),
};

export default {
  name: 'RealNumberDisplayField',
  mixins: [
    BaseControlMixin,
  ],
  computed: {
    value() {
      const formatFunc = formats[this.getSingleVar.format || defaultFormat];
      return formatFunc(this.getSingleVar.value);
    },
  },
};
</script>

<style scoped>

</style>
